import React from "react";
import { pantImageOptions } from "../../data/image-options";
import StylePicker from "./StylePicker";

const PantImageDropdown = ({ formik }) => (
  <StylePicker
    options={pantImageOptions}
    value={formik.values.customer.pant.image}
    onChange={(key) => formik.setFieldValue("customer.pant.image", key)}
  />
);

export default PantImageDropdown;
